import { useDispatch } from "react-redux";
import { useMutation } from "@tanstack/react-query"

import { solicitarConfirmacionCita } from "../services/citas.service";

import { successNotification, dangerNotification } from '../../../redux/slices/ui';

export const useCitaSolicitarConfirmacion = () => {

    const dispatch = useDispatch();

    const solicitarConfirmacionCitaMutation = useMutation({
        mutationFn: solicitarConfirmacionCita,
        onSuccess: (cita, variables, context) => {
            variables.success();
            dispatch(successNotification('Solicitud de confirmación de cita enviada'));
        },
        onError: (error, variables, context) => {
            variables.error();
            dispatch(dangerNotification(error.message));
            // dispatch(dangerNotification(error.msg.message));
        }
    });

    return {
        solicitarConfirmacionCitaMutation,
    }
}